import { isPlatformBrowser } from '@angular/common';
import { afterNextRender, Component, Inject, OnInit, OnDestroy, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuModel } from '@models/menuModel';
import { ProductosServicesService } from '@services/productos-services.service';
import { Subscription } from 'rxjs';
import { BreadcrumbService } from '@services/breadcrumb.service';
import { Breadcrumb } from '@models/breadcrumb.model';
import { SeoService } from '@services/seo.service';
import { categoryPath, productPath, slugify } from '@services/seo-url.util';
import { CATEGORY_IDS_BY_SLUG } from '@services/seo-routes.data';
import { safeLocalStorage, safeSessionStorage } from '@shared/safe-web-storage';

@Component({
  selector: 'app-productos',
  templateUrl: './productos.component.html',
  styleUrls: ['./productos.component.css'],
  standalone: false,
})
export class ProductosComponent implements OnInit, OnDestroy {
  private readonly categoryMediaBaseUrl = 'https://clavemusica.com/';
  public lsProd: any[] = [];
  public totalProductos: number = 0;
  public OrderSelected: number = 0;
  public ParamCategoria: string = '';
  public ParamBusqueda: string = '';
  public MenuFinal: Array<MenuModel> = [];
  public categoriasFiltro: Array<string> = [];
  public MenuCategoriaImagenes: Array<object> = [];
  public catHijasSlider: any[] = [];
  public cargaloader = true;
  private categoryLabel = '';
  private readonly accessoryLinks: Record<string, { IdCategoria: number; Categoria: string; label: string }> = {
    '6': { IdCategoria: 21, Categoria: 'Accesorios Saxofon', label: 'Saxofón' },
    '7': { IdCategoria: 22, Categoria: 'Accesorios Clarinete', label: 'Clarinete' },
    '8': { IdCategoria: 23, Categoria: 'Accesorios Flauta Piccolo', label: 'Flauta' },
    '14': { IdCategoria: 25, Categoria: 'Accesorios Trompeta Corneta Fliscorno', label: 'Trompeta' },
    '15': { IdCategoria: 26, Categoria: 'Accesorios Trombon', label: 'Trombón' },
    '111': { IdCategoria: 24, Categoria: 'Accesorios Cana Doble', label: 'Cañas Dobles' }
  };

  // Variables para paginación
  public currentItemsToShow: any[] = [];
  public currentPage: number = 1;
  public pageSize: number = 12;
  public pageSizeOptions: number[] = [8, 12, 24];
  private routeSubscription!: Subscription;

  public maxPagesToShow: number = 12;
  public startPage: number = 1;
  public endPage: number = this.maxPagesToShow;

  constructor(
    protected ProdService: ProductosServicesService,
    protected rt: ActivatedRoute,
    public router: Router,
    private breadcrumbService: BreadcrumbService,
    private seo: SeoService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    afterNextRender(() => {
      this.MenuFinal = this.readStoredMenu();
    });
  }

  async ngOnInit() {
    // Escuchar cambios en los parámetros de la ruta para recargar
    this.routeSubscription = this.rt.paramMap.subscribe(params => {
      this.cargaloader = true;
      this.ParamCategoria = params.get('IdCategoria')
        || CATEGORY_IDS_BY_SLUG[params.get('slug') || '']
        || '';
      this.ParamBusqueda = params.get('Busqueda') || '';
      if (this.ParamBusqueda === '-') this.ParamBusqueda = '';
      
      this.currentPage = 1; // Resetear paginación en cambio de categoría/búsqueda
      this.lsProd = [];
      this.currentItemsToShow = [];
      this.MenuCategoriaImagenes = [];
      this.catHijasSlider = [];

      this.loadData();
    });

  }

  async loadData() {
    try {
      this.setBreadcrumbs(); // Configurar breadcrumbs aquí
      this.updateSeo();

      // Primero obtenemos las categorías para el slider y breadcrumbs
      if (this.ParamCategoria) { // Solo si hay categoría principal
          await this.ObtenCategoriasNavegacionSlider();
      }
      // Luego los productos
      await this.ObtenProductos(this.ParamCategoria, '', this.ParamBusqueda);

    } catch (error) {
      console.error('Error al cargar datos iniciales:', error);
    } finally {
      this.cargaloader = false;
    }
  }

  ngOnDestroy() {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  async setBreadcrumbs() {
    const breadcrumb: Breadcrumb[] = [ ];

    try {

      const catData = await this.ProdService.getCatNavegacion(this.ParamCategoria);

      if (Array.isArray(catData)) {

        catData.map( (cat:any) =>

          breadcrumb.push({
            label: cat.Categoria,
            url: categoryPath(cat)
          })

        )

        const currentCategory = catData.find((cat: any) =>
          String(cat.IdCategoria ?? cat.IdCat) === String(this.ParamCategoria)
        ) || catData[catData.length - 1];
        this.categoryLabel = currentCategory?.Categoria
          || currentCategory?.DescCategoria
          || currentCategory?.Ruta
          || '';
        this.updateSeo();
        if (this.isBrowser && currentCategory) {
          const canonicalPath = categoryPath(currentCategory);
          if (this.router.url.split('?')[0] !== canonicalPath) {
            this.router.navigateByUrl(canonicalPath, { replaceUrl: true });
          }
        }

      }
    }catch (error){
        console.error('Error al obtener categoria', error);
        
      }

    this.breadcrumbService.setBreadcrumbs(breadcrumb);

  }



  async ObtenProductos(cat: string, marca: string, busqueda: string) {
    const categoriaParam = Array.isArray(this.categoriasFiltro) && this.categoriasFiltro.length > 0 ? this.categoriasFiltro.join(',') : cat;

    if (!categoriaParam && !busqueda) {
      this.lsProd = [];
      this.currentItemsToShow = [];
      this.totalProductos = 0;
      return;
    }

    this.cargaloader = true;
    try {
      // Restaurar estado si venimos del detalle de un producto
      const savedStateRaw = this.isBrowser ? safeSessionStorage.getItem('catalogState') : null;
      if (savedStateRaw) {
        const state = JSON.parse(savedStateRaw);
        if (state.ParamCategoria === this.ParamCategoria && state.ParamBusqueda === this.ParamBusqueda) {
          this.OrderSelected = state.OrderSelected;
          this.pageSize = state.pageSize;
          this.currentPage = state.currentPage;
        }
        safeSessionStorage.removeItem('catalogState');
      }

      const result = await this.ProdService.ConsultaProductos(
        categoriaParam, marca, busqueda, '', 1,
        this.currentPage, this.pageSize, this.OrderSelected
      );
      this.lsProd = result.data ?? [];
      this.totalProductos = result.total ?? 0;
      this.currentItemsToShow = this.lsProd;
      this.updatePageRange();

    } catch (error) {
      console.error('Error al obtener productos:', error);
      this.lsProd = [];
      this.currentItemsToShow = [];
      this.totalProductos = 0;
    } finally {
      this.cargaloader = false;
    }
  }

  async ObtenCategoriasNavegacionSlider() {
    if (!this.ParamCategoria) {
        this.MenuCategoriaImagenes = []; // Limpiar si no hay categoría padre
        return;
    }
    try {
      const catnav = await this.ProdService.getCatNavegacion(this.ParamCategoria);
      
      if (Array.isArray(catnav) && catnav.length > 0) {
        this.catHijasSlider = catnav[0]?.CategoriasHijas || [];
        this.CargaImagenesSlider(this.catHijasSlider);
      } else {
        this.catHijasSlider = [];
        this.MenuCategoriaImagenes = [];
      }
    } catch (error) {
      console.error('Error al obtener categorías de navegación:', error);
    }
  }

  CargaImagenesSlider(categoriasHijas: any[]) {
    this.MenuCategoriaImagenes  = categoriasHijas.map((item: any) => ({
      image: this.categoryImageUrl(item.Imagen),
      thumbImage: this.categoryImageUrl(item.Imagen),
      alt: item.Ruta || item.Categoria,
      title: item.Ruta || item.Categoria,
      idCategoria: item.IdCategoria
    }));
  }

  public categoryImageUrl(rawUrl: unknown): string {
    const value = String(rawUrl ?? '').trim();
    if (!value) return this.categoryMediaUrl('Public/Img/Productos/Default.jpg');
    if (/^(?:data:|blob:)/i.test(value)) return value;

    if (/^https?:/i.test(value)) {
      const absoluteUrl = new URL(value);
      const isCategoryMediaHost = [
        'clavewinds.shop',
        'www.clavewinds.shop',
        'clavemusica.com',
        'www.clavemusica.com',
        'api.clavemusica.com'
      ]
        .includes(absoluteUrl.hostname.toLowerCase());

      if (!isCategoryMediaHost) return value;

      return this.categoryMediaUrl(`${absoluteUrl.pathname}${absoluteUrl.search}${absoluteUrl.hash}`);
    }

    return this.categoryMediaUrl(value);
  }

  private categoryMediaUrl(path: string): string {
    const normalizedPath = path
      .replace(/^\/+/, '')
      .replace(/^api\//i, '');

    return new URL(normalizedPath, this.categoryMediaBaseUrl).toString();
  }

  public subcategoryPath(category: any): string {
    return categoryPath(category);
  }

  public subcategoryLabel(category: any): string {
    return String(category?.Categoria || category?.DescCategoria || category?.Ruta || 'Subcategoría')
      .replace(/-/g, ' ');
  }

  imageClickHandler(eventIndex: number) {
    const selectedCategory = this.catHijasSlider[eventIndex];
    if (selectedCategory && selectedCategory.IdCategoria) {
      this.router.navigateByUrl(categoryPath(selectedCategory));
    }
  }



  BuscarPorFiltroCategoria(IdCategoria: any, event: any) {
    const chk = event.target as HTMLInputElement;
    if (chk.checked) {
      if (!this.categoriasFiltro.includes(IdCategoria)) {
        this.categoriasFiltro.push(IdCategoria);
      }
    } else {
      this.quitarCategoriaFiltro(IdCategoria);
    }
    this.currentPage = 1;
    this.ObtenProductos(this.ParamCategoria, '', this.ParamBusqueda);
  }

  quitarCategoriaFiltro(item: any) {
    const index = this.categoriasFiltro.indexOf(item);
    if (index !== -1) {
      this.categoriasFiltro.splice(index, 1);
    }
  }

  public detalleProducto(prod: any) {
    if (this.isBrowser) {
      safeSessionStorage.setItem('catalogState', JSON.stringify({
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        OrderSelected: this.OrderSelected,
        ParamCategoria: this.ParamCategoria,
        ParamBusqueda: this.ParamBusqueda
      }));
      safeSessionStorage.setItem('IdProd', JSON.stringify(prod.IdProducto));
    }
    this.router.navigateByUrl(productPath(prod));
  }

  public productPath(prod: any): string {
    return productPath(prod);
  }

  public get currentAccessoryLink() {
    return this.accessoryLinks[String(this.ParamCategoria)];
  }

  public accessoryPath(): string {
    return categoryPath(this.currentAccessoryLink);
  }

  // El ordenamiento se hace server-side: relanzar la búsqueda desde la página 1
  Ordenar() {
    this.currentPage = 1;
    this.ObtenProductos(this.ParamCategoria, '', this.ParamBusqueda);
  }

  updateCurrentItems() {
    // Con paginación server-side los items ya vienen paginados
    this.currentItemsToShow = this.lsProd;
  }

  onPageChangeManual(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.ObtenProductos(this.ParamCategoria, '', this.ParamBusqueda);
      this.updatePageRange();
      if (this.isBrowser) window.scrollTo(0, 0);
    }
  }

  onPageSizeChange() {
    this.currentPage = 1;
    this.ObtenProductos(this.ParamCategoria, '', this.ParamBusqueda);
    this.updatePageRange();
  }

  get totalPages(): number {
    return Math.ceil(this.totalProductos / this.pageSize);
  }

  totalPagesArray(): number[] {
    if (this.lsProd.length === 0) return [];
    
    let pages: number[] = [];
    for (let i = this.startPage; i <= this.endPage; i++) {
      pages.push(i);
    }
    
    return pages;
  }

    // Método para actualizar el rango de páginas mostradas
  updatePageRange() {
    if (this.totalPages <= this.maxPagesToShow) {
      this.startPage = 1;
      this.endPage = this.totalPages;
    } else {
      let start = Math.max(1, this.currentPage - Math.floor(this.maxPagesToShow / 2));
      let end = start + this.maxPagesToShow - 1;

      if (end > this.totalPages) {
        end = this.totalPages;
        start = Math.max(1, end - this.maxPagesToShow + 1);
      }

      this.startPage = start;
      this.endPage = end;
    }
  }

// Método para ir a la página anterior en el rango
  goToPreviousRange() {
    this.currentPage = this.startPage - 1;
    this.updatePageRange();
    this.updateCurrentItems();
    if (this.isBrowser) window.scrollTo(0, 0);
  }

  // Método para ir a la página siguiente en el rango
  goToNextRange() {
    this.currentPage = this.endPage + 1;
    this.updatePageRange();
    this.updateCurrentItems();
    if (this.isBrowser) window.scrollTo(0, 0);
  }

  // Método para verificar si hay un rango anterior
  hasPreviousRange(): boolean {
    return this.startPage > 1;
  }

  // Método para verificar si hay un rango siguiente
  hasNextRange(): boolean {
    return this.endPage < this.totalPages;
  }

  private updateSeo() {
    const categoryLabel = this.categoryLabel || this.rt.snapshot.paramMap.get('Cat') || 'productos';
    const readableCategory = categoryLabel === 'productos' ? categoryLabel : slugify(categoryLabel).replace(/-/g, ' ');
    const title = this.ParamBusqueda
      ? `Busqueda: ${this.ParamBusqueda} | Clave Winds`
      : `Productos de ${readableCategory} | Clave Winds`;

    const path = this.router.url.split('?')[0];
    this.seo.update({
      title,
      description: this.ParamBusqueda
        ? `Resultados para ${this.ParamBusqueda}: instrumentos musicales, accesorios y refacciones disponibles en Clave Winds.`
        : this.categoryLabel
          ? `Compra ${this.categoryLabel} en Clave Winds. Encuentra productos especializados, accesorios y refacciones con envios en Mexico.`
          : 'Compra instrumentos musicales de viento, accesorios, refacciones y productos especializados en Clave Winds.',
      canonical: this.seo.absoluteUrl(path)
    });
  }

  private get isBrowser() {
    return isPlatformBrowser(this.platformId);
  }

  private readStoredMenu(): Array<MenuModel> {
    if (!this.isBrowser) return [];

    try {
      const storedMenu = JSON.parse(safeLocalStorage.getItem('Menu') || '[]');
      return Array.isArray(storedMenu) ? storedMenu : [];
    } catch {
      safeLocalStorage.removeItem('Menu');
      return [];
    }
  }


}
